import { useUnmountedRef, useUpdate } from 'ahooks';
import { useEffect, useRef } from 'react';
/**
 * open 由false => true时，open为true，animationOpenRef.current为true，
 * open由true => false时，animationOpenRef.current为true, 300ms后animationOpenRef.current为false
 * @param open
 * @returns
 */
export const useDialogVisible = (open: boolean) => {
  const animationOpenRef = useRef<boolean>(false);
  const unmountedRef = useUnmountedRef();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const timerRef = useRef<any>(null);
  const update = useUpdate();
  useEffect(() => {
    clearTimeout(timerRef.current);
    if (open) {
      animationOpenRef.current = open;
    } else {
      timerRef.current = setTimeout(() => {
        animationOpenRef.current = open;
        clearTimeout(timerRef.current);
        if (!unmountedRef.current) {
          update();
        }
      }, 600);
    }
  }, [open, unmountedRef, update]);
  return open || animationOpenRef.current;
};
